<template>
  <div class="w-full">
    <label
      v-if="label"
      class="text-dark"
    >{{ label }}</label>
    <div
      class="xn-form-group flex flex-row flex-wrap w-full items-center"
      :style="justifyContent"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'XnFormGroup',
  props: {
    label: { type: String, default: null },
    justifyContent: { type: String, default: 'justify-around' },
  },
}
</script>
<style lang="postcss" scoped>
.xn-form-group .xn-input {
  @apply w-full sm:w-1/3;
}
</style>
